import React from 'react';
import { NavLink } from 'react-router-dom';

type Props = {
  icon: React.ElementType;
  to: string;
  showTitle: boolean;
  styleSlug?: string;
};

const NavItem: React.FC<Props> = ({
  icon: Icon,
  to,
  showTitle = true,
  styleSlug = 'eth',
  children,
}) => (
  <li>
    <NavLink
      to={to}
      className="group block h-12 pl-4 pr-6 border-l-4 border-transparent"
      activeClassName={`border-${styleSlug}-primary dark:border-${styleSlug}-light`}
      exact={to === '/'}
    >
      <span
        className={`inline-block h-full ${
          showTitle ? 'rounded-10' : 'rounded-full'
        } bg-gradient-to-l group-hover:bg-${styleSlug}-light dark:group-hover:from-${styleSlug}-light dark:group-hover:to-${styleSlug}-primary`}
        style={{ padding: 2 }}
      >
        <span
          className={`inline-flex w-full items-center space-x-4 p-2.5 whitespace-nowrap bg-white dark:bg-gray-111 ${
            showTitle ? 'rounded-8 pr-5' : 'rounded-full'
          }`}
        >
          <Icon className="w-6 h-6" />
          {showTitle && <span>{children}</span>}
        </span>
      </span>
    </NavLink>
  </li>
);

export default NavItem;
